import {Link} from 'react-router';

export type SecondaryDestination={id:string;label:string;href:string};
/** The second horizontal bar. Every destination stays visible; the row wraps rather than hiding links. */
export function SecondaryNavigation({items,active,label}:{items:SecondaryDestination[];active?:string|undefined;label:string}){
 if(!items.length)return null;
 return <nav className="building-primary-nav" aria-label={label}>{items.map(item=><Link key={item.id} to={item.href} state={{buildingArea:true}} aria-current={active===item.id?'page':undefined}>{item.label}</Link>)}</nav>;
}
